import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { CommonService } from 'src/app/services/common.service';
import { environment } from 'src/environments/environment';
@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {
  RESOURCE_SERVER_URL = environment.RESOURCE_SERVER_URL;
  CONTEXT_PATH = environment.CONTEXT_PATH;
  tickmark = this.RESOURCE_SERVER_URL + '/assets/images/Underwriting_new/Underwriting/Loading and Counter Offer/Right_tick.svg';
  logoSrc= `${this.RESOURCE_SERVER_URL}/assets/images/footer/DXC_Logo_white.svg`;
  showbutton=false
  footerBottomLinks = [] as any;
  detail: { [unit: string]: any } = {};
  footerSocialLinks = [] as any;
  message:any="";
  dxc:string | undefined;
  policy:string | undefined;
  terms:string | undefined;
  isVisible: boolean=false;
  underwriterid
  constructor(private translate : TranslateService,
    private commonService:CommonService,
    private router: Router) {
    this.commonService.currentSuccessMessage.subscribe(data => {
if(data.isVisible){
  this.isVisible =data.isVisible;
 this.message= data.message;
 this.showbutton=data.showbutton
 this.underwriterid=data.uuid
 if(!data.showbutton){
  this.unSubscibe();
 }
}
else{
this.isVisible =data.isVisible;
this.showbutton=data.showbutton
}  
})
  }
  ngOnInit(): void {
    this.initFooterData();
  }
  unSubscibe(){
    setTimeout(() => {
      this.commonService.changeSuccessMessage({
        isVisible:false,
        message:"",
        showbutton:false,
        uuid:''
      })
      // this.isVisible=false
      
     }, 2000);
    
  }
  async initFooterData() {
    this.footerSocialLinks = [
      {
        href: 'https://www.facebook.com/DXCTechnology/',
        logoSrc: this.CONTEXT_PATH + '/assets/images/footer/facebook.svg'
      },
      {
        href: 'https://twitter.com/dxctechnology',
        logoSrc: this.CONTEXT_PATH + '/assets/images/footer/twitter.svg'
      },
      {
        href: 'https://www.linkedin.com/company/dxctechnology',
        logoSrc: this.CONTEXT_PATH + '/assets/images/footer/linkedin.svg'
      },
    ];
    this.translate.get('footer.dxc').subscribe(r => {this.dxc = r});
    this.translate.get('footer.policy').subscribe(r => {this.policy = r});
    this.translate.get('footer.terms').subscribe(r => {this.terms = r});
    this.footerBottomLinks = [
      {
        href: '',
        text: this.dxc
      },
      {
        href: '',
        text: this.policy
      },
      {
        href: '',
        text: this.terms
      }
    ]
    }
    homepage(){
      this.commonService.changeSuccessMessage({
        isVisible:false,
        message:"",
        showbutton:false,
        uuid:''
      })
      this.router.navigate([`/under-writing/${this.underwriterid}/underwriting-detail`]);
    }
}
